

import { defineComponent, toRaw } from 'vue';


export default defineComponent({
    data() {
        return {

        }

    },
    mounted() {
        const closeModalButton = document.getElementById('closeNoteModal');
        if (closeModalButton) {
            closeModalButton.addEventListener('click', () => {
                const video = document.getElementById('videoPlayer') as HTMLVideoElement;
                if (video) {
                    video.pause();
                }
            });
            // const videos = document.querySelectorAll('video');
            //     videos.forEach(video => {
            //         if (!video.paused) {
            //             video.pause();
            //         }
            //     })
        }
    }

});




// btn.onclick = function() {
//     modal.style.display="block";
// //     videoPlayer.play();
// // }

// // close.onclick = function() {
// //     modal.style.display="none";
// //     videoPlayer.pause();
// //     videoPlayer.currentTime = 0;
// }
